import React from 'react';
import { CheckCircle } from '@mui/icons-material';

const styles = {
    stepperContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '32px',
        padding: '0 20px',
    },
    stepWrapper: {
        display: 'flex',
        alignItems: 'center',
        flex: 1,
        maxWidth: '200px',
    },
    stepCircle: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        fontWeight: 'bold',
        transition: 'all 0.3s',
        flexShrink: 0,
    },
    stepCircleActive: {
        backgroundColor: '#3c7e2d',
        color: '#fff',
        border: '3px solid #3c7e2d',
    },
    stepCircleCompleted: {
        backgroundColor: '#3c7e2d',
        color: '#fff',
        border: '3px solid #3c7e2d',
    },
    stepCircleInactive: {
        backgroundColor: '#f5f5f5',
        color: '#999',
        border: '3px solid #ddd',
    },
    stepLine: {
        flex: 1,
        height: '3px',
        margin: '0 8px',
        transition: 'all 0.3s',
    },
    stepLineCompleted: {
        backgroundColor: '#3c7e2d',
    },
    stepLineInactive: {
        backgroundColor: '#ddd',
    },
    stepLabel: {
        position: 'absolute',
        top: '50px',
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: '12px',
        fontWeight: '500',
        whiteSpace: 'nowrap',
        transition: 'all 0.3s',
    },
    stepLabelActive: {
        color: '#3c7e2d',
        fontWeight: 'bold',
    },
    stepLabelCompleted: {
        color: '#3c7e2d',
    },
    stepLabelInactive: {
        color: '#999',
    },
    stepContainer: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
    },
    lastStep: {
        marginRight: 0,
    }
};

export default function SignupStepper({ currentStep }) {
    const steps = [
        { number: 1, label: 'Account Info' },
        { number: 2, label: 'Verify Email' },
        { number: 3, label: 'Create Password' }
    ];

    const getStepStyle = (stepNumber) => {
        if (stepNumber < currentStep) {
            return styles.stepCircleCompleted;
        } else if (stepNumber === currentStep) {
            return styles.stepCircleActive;
        } else {
            return styles.stepCircleInactive;
        }
    };

    const getLabelStyle = (stepNumber) => {
        if (stepNumber < currentStep) {
            return styles.stepLabelCompleted;
        } else if (stepNumber === currentStep) {
            return styles.stepLabelActive;
        } else {
            return styles.stepLabelInactive;
        }
    };

    const getLineStyle = (stepNumber) => {
        // Line appears after this step
        if (stepNumber < currentStep) {
            return styles.stepLineCompleted;
        } else {
            return styles.stepLineInactive;
        }
    };

    return (
        <div style={styles.stepperContainer}>
            {steps.map((step, index) => (
                <React.Fragment key={step.number}>
                    <div style={styles.stepContainer}>
                        <div style={{
                            ...styles.stepCircle,
                            ...getStepStyle(step.number)
                        }}>
                            {step.number < currentStep ? (
                                <CheckCircle style={{ fontSize: '24px' }} />
                            ) : (
                                step.number
                            )}
                        </div>
                        <div style={{
                            ...styles.stepLabel,
                            ...getLabelStyle(step.number)
                        }}>
                            {step.label}
                        </div>
                    </div>
                    {index < steps.length - 1 && (
                        <div style={{
                            ...styles.stepLine,
                            ...getLineStyle(step.number)
                        }} />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
}
